export default __webpack_public_path__ + "static/media/signal-4.9b51f5c6.svg";